import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronUp } from "lucide-react";
import { CONSENT_CHANGED_EVENT, hasDecided } from "@/lib/cookieConsent";

const BackToTop = () => {
    const [show, setShow] = useState(false);
    // Hide button while the cookie banner is visible to avoid visual collision
    // in the bottom-left corner.
    const [bannerDecided, setBannerDecided] = useState(() => hasDecided());

    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > 600);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        const onConsent = () => setBannerDecided(hasDecided());
        window.addEventListener(CONSENT_CHANGED_EVENT, onConsent);
        return () => {
            window.removeEventListener("scroll", onScroll);
            window.removeEventListener(CONSENT_CHANGED_EVENT, onConsent);
        };
    }, []);

    const goTop = () => {
        if (typeof window === "undefined") return;
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const visible = show && bannerDecided;

    return (
        <AnimatePresence>
            {visible ? (
                <motion.button
                    type="button"
                    onClick={goTop}
                    aria-label="Retour en haut de la page"
                    data-testid="back-to-top"
                    initial={{ opacity: 0, scale: 0.85, y: 12 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.85, y: 12 }}
                    transition={{ duration: 0.2 }}
                    className="fixed left-5 bottom-6 z-[45] w-11 h-11 rounded-xl bg-brand-dark/85 hover:bg-brand-dark backdrop-blur-sm text-white shadow-lg flex items-center justify-center transition-colors"
                >
                    <ChevronUp className="w-6 h-6" />
                </motion.button>
            ) : null}
        </AnimatePresence>
    );
};

export default BackToTop;
